@if (permissionsExist$ | async) {
  <app-no-required-permissions></app-no-required-permissions>
} @else {
  <app-no-role></app-no-role>
}
